import React from "react";
import { useTranslation } from "react-i18next";
import "./differential.scss";

const Differential = () => {
    const { t } = useTranslation()
    return (
        <div className="container-differential">
            <div className="text-differential">
                <h1>{t("home.differential.title")}</h1>
                <p>{t("home.differential.section_text")}</p>
            </div>
        </div>
    );
}
export default Differential;